import script from "./ConversationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationList.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationList.vue?vue&type=style&index=0&id=c6d4495e&scope=true&lang=postcss"

export default script